import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const OPTIONS = [
  {
    value: 'do-not-track',
    translationKey: 'pages.onboarding.trackSpending.options.do-not-track',
  },
  {
    value: 'use-notes-apps',
    translationKey: 'pages.onboarding.trackSpending.options.use-notes-apps',
  },
  {
    value: 'keep-receipts-folder',
    translationKey:
      'pages.onboarding.trackSpending.options.keep-receipts-folder',
  },
  {
    value: 'automation',
    translationKey: 'pages.onboarding.trackSpending.options.automation',
  },
]

export default function TrackSpendingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.trackSpending.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
